import PageBuilderSelector from '@v4/utils/selectors/PageBuilderSelector'
import AppStore from '@v4/store/appStore'
import { useSectionId } from '@v4/components/common/SectionItem'
import useStyles from './ItemBorder.styled'

const useItemBorder = props => {
	const { children, categoryId = null, itemKey = null, group = null, outlineOffset = 0 } = props

	const sectionId = useSectionId()
	const classes = useStyles({ ...props, categoryId, itemKey, group, outlineOffset })
	const activeCategoryId = PageBuilderSelector.useIsMetaCategoryActive({
		sectionId,
		categoryId,
		group,
	})
	const activeItemKey = PageBuilderSelector.useIsMetaItemActive({ sectionId, itemKey, group })
	const isBuilderMode = AppStore.useStoreState(state => state.general.isBuilderMode)

	return [
		{
			classes,
			children,
			isActive: activeCategoryId || activeItemKey,
			isBuilderMode,
		},
	]
}

export default useItemBorder
